/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Faq_1_QuestionInputs */

const en_svc_research_faq_1_question = /** @type {(inputs: Svc_Research_Faq_1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is a research agent different from asking ChatGPT?`)
};

const lv_svc_research_faq_1_question = /** @type {(inputs: Svc_Research_Faq_1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ar ko izpētes aģents atšķiras no jautājuma ChatGPT?`)
};

/**
* | output |
* | --- |
* | "How is a research agent different from asking ChatGPT?" |
*
* @param {Svc_Research_Faq_1_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_faq_1_question = /** @type {((inputs?: Svc_Research_Faq_1_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Faq_1_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_faq_1_question(inputs)
	return en_svc_research_faq_1_question(inputs)
});